/**
 * Created by mukund on 7/19/15.
 */

angular.module('mediacloudApp')
    .directive('ssPlayer', ['AssetService','AVMedia','BlobMedia', 'ZipMedia', 'mediaDropOff', 'mediaPauseAndDropOff', 'CollectionService', function(AssetService, AVMedia, BlobMedia, ZipMedia, mediaDropOff, mediaPauseAndDropOff, CollectionService){

        return {
            restrict: 'E',
            replace: true,
            scope: {
                asset: '=',
                captionsupdated: '='
            },
            template: '<div id="player" role="application" tabindex="0" class="fp-fat no-buffer"></div>',
            link: function(scope, element, attrs){

                var AUTHTOKEN=scope.$root.AUTHTOKEN;

                mediaDropOff.videoPlayed = false;
                mediaDropOff.hasFinished = false;
                mediaPauseAndDropOff.isPlayed = false;
                mediaPauseAndDropOff.isPaused = false;

                //adopted from http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });

                if (!document.cookie.match(/^(.*;)?\s*ss_identifier=[^;]+(.*)?$/)) {
                    document.cookie = 'ss_identifier=' + uuid + '; expires=Tue, 19 Jan 2038 03:14:07 UTC; path=/';
                }

                /**
                 * This method parses subtitles and truncates them for clips
                 *
                 * @param txt
                 * @returns {Array}
                 */
                var parseSubtitles = function(txt) {
                    var self = this;
                    var TIMECODE_RE = /^(([0-9]{2}:){1,2}[0-9]{2}[,.][0-9]{3}) --\> (([0-9]{2}:){1,2}[0-9]{2}[,.][0-9]{3})(.*)/;

                    function seconds(timecode) {
                        var els = timecode.split(':');
                        if (els.length == 2) els.unshift(0);
                        return els[0] * 60 * 60 + els[1] * 60 + parseFloat(els[2].replace(',','.'));
                    }

                    var entries = [];
                    var start, end;
                    for (var i = 0, lines = txt.split("\n"), len = lines.length, entry = {}, title, timecode, text; i < len; i++) {
                        timecode = TIMECODE_RE.exec(lines[i]);

                        if (timecode) {

                            // title
                            title = lines[i - 1];

                            // text
                            text = "<p>" + lines[++i] + "</p><br/>";
                            while (typeof lines[++i] === 'string' && lines[i].trim() && i < lines.length) text +=  "<p>" + lines[i] + "</p><br/>";

                            start = seconds(timecode[1]);
                            end = seconds(timecode[3]);

                            // These properties are set at the player level in FlowPlayer when playing ShareStream clips
                            if(self.start && self.end) {
                                // Discard subtitles which are outside the bounds of the clip
                                if(self.start > end || start > self.end){
                                    continue;
                                }
                                // Subtract the offset (self.start) from the start and end times of the subtitle, so they match the clip
                                start -= self.start;
                                if(start < 0) {
                                    start = 0;
                                }
                                end -= self.start;
                            }

                            // entry
                            entry = {
                                title: title,
                                startTime: start,
                                endTime: end,
                                text: text
                            };
                            entries.push(entry);
                        }
                    }
                    return entries;
                };

                function waitForElement(c, callback){
                    var poops = setInterval(function(){
                        if($(c).length > 0){
                            clearInterval(poops);
                            callback();
                        }
                    }, 100);
                }

                waitForElement(".fp-audio", function(){
                   $('.fp-audio')
                        .attr({'tabindex':0,'aria-label':'Click to show audio tracks'})
                        .focus(function() {
                            $('.fp-audio').css({"outline": "#0b5fcc solid thick"});
                        }).blur(function() {
                            $('.fp-audio').css({"outline": "none"});
                        })
                        .keypress(function(evt) {
                            if (evt.keyCode == 13 || evt.keyCode == 32) {
                                evt.preventDefault();
                                evt.stopPropagation();
                                $('.fp-audio').click();
                            }
                        });
                   $('.fp-audio-menu a')
                       .attr({'tabindex':0})
                       .keypress(function(evt) {
                           console.log($(evt.target))
                           if (evt.keyCode == 13 || evt.keyCode == 32) {
                               evt.preventDefault();
                               evt.stopPropagation();
                               $(evt.target).get(0).click();
                           }
                   });
                });

                var getAVMedia = function(clip){

                    var aid = scope.asset.aid;

                    if(clip && clip.originAid) {
                        aid = clip.originAid;
                    }

                    AVMedia.get({
                        cid: scope.asset.cid,
                        aid: aid
                    }, function (media) {

                        var hlsUrl = media.mediaUrl + "/playlist.m3u8?authToken="+(AUTHTOKEN?AUTHTOKEN:JSON.parse(localStorage.getItem("ls.authToken"))),
                            clipStart = 0,
                            clipEnd = undefined;

                        if(clip && clip.startTime && clip.endTime){
                            clipStart = timeInSeconds(clip.startTime);
                            clipEnd = timeInSeconds(clip.endTime);
                            var duration = clipEnd - clipStart + 1;

                            hlsUrl += "&wowzaplaystart=" + (clipStart * 1000);

                            // For ShareStream clips
                            if(duration){
                                hlsUrl += "&wowzaplayduration=" + (duration * 1000);
                            }
                        }

                        // Attach the media clip - this is the Flowplayer clip (i.e. video). This has nothing to do with ShareStream clip feature.
                        var ssClip = {
                            flashls: {
                                    // limit amount of retries to load hls manifests in Flash
                                    manifestloadmaxretry: 2
                            },
                            sources: [
                                {type: "application/x-mpegurl", src: hlsUrl}
                            ],
                            subtitles: []
                        };

                        var playerConf = {
                            hlsjs: {
                                xhrSetup: function(xhr, url) {
                                    xhr.withCredentials = true;
                                    xhr.setRequestHeader("x-auth-token",AUTHTOKEN?AUTHTOKEN:JSON.parse(localStorage.getItem("ls.authToken")));
                                },
                                safari: true,
                                recoverMediaError: true,
                                recoverNetworkError: true

                            },
                            hlsQualities: false,
                            keyboard: false,
                            key: (media.playerKey ? media.playerKey : '$385212986718610'),
                            swfHls: '/assets/flowplayer/flowplayerhls.swf',
                            swf: '/assets/flowplayer/flowplayer.swf'
                        };

                        if(scope.asset.type === 'Audio'){
                            var showCoverArt = false;
                            var url = "./api/feature-flags"
                            //TODO: Refactor to retrieve feature flags on startup.
                            $.ajax({
                                url: url,
                                async: false,
                                type: 'GET',
                                success: function(data) {
                                    scope.showCoverArt = data.showCoverArt;
                                }
                            });

                            if(scope.showCoverArt === "true"){
                               playerConf.audio = true;
                               playerConf.subtitleParser = parseSubtitles;
                               playerConf.splash = scope.asset.thumbnailUrl;
                               ssClip.coverImage = scope.asset.thumbnailUrl;
                            }
                            else{
                               playerConf.audioOnly = true;
                               playerConf.splash = true;
                            }
                            if (scope.asset.ccAvailable) {
                               scope.captionsIncluded = false;
                               scope.subtitlesIncluded = false;
                               var split = scope.asset.language.split('- ');
                               var srcLang = "English";
                               if (split.length > 1) {
                                    srcLang = split[1];
                               }
                               $.each(JSON.parse(media.captions), function (i, k) {
                               if (!k.title.includes("Audio Description") && k.language === srcLang) {
                               	    k.title += " [CC]";
                               }
                               if (k.language === srcLang) {
                                    scope.captionsIncluded = true;
                               }
                               else if (k.language !== srcLang) {
                                    scope.subtitlesIncluded = true;
                               }
                               k.captionUrl = media.captionUrl + '&id=' + k.id;
                                   ssClip.subtitles.push(
                                   {
                                       "default": k.enabledByDefault,
                                       kind: "subtitles",
                                       srclang: srcLang,
                                       label: k.title,
                                       src: k.captionUrl
                                   });
                               });
                               if (scope.subtitlesIncluded) {
                                    scope.ccMenuTitle = 'Closed Captions & Subtitles';
                               }
                               else {
                                    $('.fp-subtitle-menu').css('visibility', 'hidden');
                                    // set it as on initially
                                    $('.fp-cc').click(function () {
                                        console.log($('.fp-selected'));
                                    });
                                    scope.ccMenuTitle = 'Closed Captions';
                               }
                            }
                           playerConf.clip = ssClip;
                        } else {

                            // The playlist array will store the clip objects to be played
                            var ssPlaylist = [];

                            // Attach the Copyright Notice clip if required
                            if (scope.asset.copyrightNoticeRequired) {
                                ssPlaylist.push({
                                    sources: [
                                        {
                                            type: "application/x-mpegurl",
                                            src: media.copyrightNoticeUrl + "/playlist.m3u8?authToken="+(AUTHTOKEN?AUTHTOKEN:JSON.parse(localStorage.getItem("ls.authToken")))
                                        }
                                    ]
                                });
                            }
                            // Attach captions to the media clip if available
                            if (scope.asset.ccAvailable) {
                               scope.captionsIncluded = false;
                               scope.subtitlesIncluded = false;
                               var split = scope.asset.language.split('- ');
                               var srcLang = "English";
                               if (split.length > 1) {
                                    srcLang = split[1];
                               }
                               $.each(JSON.parse(media.captions), function (i, k) {
                               if (!k.title.includes("Audio Description") && k.language === srcLang) {
                               	    k.title += " [CC]";
                               }
                               if (k.language === srcLang) {
                                    scope.captionsIncluded = true;
                               }
                               else if (k.language !== srcLang) {
                                    scope.subtitlesIncluded = true;
                               }
                               k.captionUrl = media.captionUrl + '&id=' + k.id;
                                   ssClip.subtitles.push(
                                   {
                                       "default": k.enabledByDefault,
                                       kind: "subtitles",
                                       srclang: srcLang,
                                       label: k.title,
                                       src: k.captionUrl
                                   });
                               });
                               if (scope.subtitlesIncluded) {
                                    scope.ccMenuTitle = 'Closed Captions & Subtitles';
                               }
                               else {
                                    scope.ccMenuTitle = 'Closed Captions';
                               }
                            }

                            document.addEventListener("DOMContentLoaded", function(event) {
                                console.log("DOM fully loaded and parsed");
                            });

                            ssPlaylist.push(ssClip);

                            playerConf.playlist = ssPlaylist;
                            playerConf.splash = scope.asset.thumbnailUrl;
                            playerConf.subtitleParser = parseSubtitles;
                        }
                        playerConf.embed = false;
                        playerConf.tooltip = false;
                        playerConf.fullscreen = true;
                        playerConf.native_fullscreen = true;
                        playerConf.share = false;
                        /* The following are custom properties for ShareStream clips */
                        playerConf.start = clipStart;
                        playerConf.end = clipEnd;

                        var api = scope.flowplayer = flowplayer(element, playerConf);
                        var player = $('.fp-ui')[0];
                        var focusTrap = window.focusTrap(player,
                                        {
                                        escapeDeactivates: false
                                        });
                        focusTrap.deactivate();

                        var lastTabTime = (new Date).getTime(),
                            lastFocusTime;

                        // Custom Code for Player Accessibility --- START //

                        $('.fp-ui')
                            .attr({'tabindex':0,'aria-label':'Click to load video'})
                            .focus(function() {
                                $('#player-container').css({"outline": "#0b5fcc solid thick"});
                            }).blur(function() {
                                $('#player-container').css({"outline": "none"});
                            }).keypress(function(evt){
                                if (evt.keyCode == 13 || evt.keyCode == 32) {
                                    api.load();
                                }
                            });

                        $('.fp-play')
                            .attr({'tabindex':0,'aria-label':'Click to play video','role':'button'})
                            .focus(function() {
                                $('#player-container').css({"outline": "#0b5fcc solid thick"});
                            }).blur(function() {
                                $('#player-container').css({"outline": "none"});
                            }).keypress(function(evt){
                                if (evt.keyCode == 13 || evt.keyCode == 32) {
                                    api.load();
                                }
                            });

                        $('.fp-playlist a').attr({'tabindex':-1,'role':'button'});

                        // Custom Code for Player Accessibility --- END //

                        api.on('load', function(){
                            // Custom Code for Player Accessibility --- START //

                            /* Add the tabindex property to each player control once the player is loaded.
                             Then, define what happens when a control is focused and a keyboard event occurs */

                            $('.fp-fullscreen')
                                .attr({'tabindex':0,'aria-label':'Click to toggle fullscreen','role':'button'})
                                .keypress(function(evt){
                                    if (evt.keyCode == 13 || evt.keyCode == 32) {
                                        evt.preventDefault();
                                        api.fullscreen();
                                        evt.stopPropagation();
                                    }
                                });

                                setTimeout(function() {
                                    $('.fp-airplay')
                                        .attr({
                                            'tabindex': 0,
                                            'aria-label': 'Click to airplay',
                                            'role':'button'
                                        })
                                        .keypress(function(evt) {
                                            if (evt.keyCode == 13 || evt.keyCode == 32) {
                                                evt.preventDefault();
                                                evt.stopPropagation();
                                            }
                                        });

                                    $('.fp-chromecast')
                                        .attr({
                                            'tabindex': 0,
                                            'aria-label': 'Click to cast',
                                            'role':'button'
                                        })
                                        .keypress(function(evt) {
                                            if (evt.keyCode == 13 || evt.keyCode == 32) {
                                                evt.preventDefault();
                                                evt.stopPropagation();
                                            }
                                        });
                                }, 1500);

                            $('.fp-playbtn')
                                .attr({'tabindex':0,'aria-label': 'Click to pause','role':'button'})
                                .keypress(function(evt){
                                    if (evt.keyCode == 13 || evt.keyCode == 32) {
                                        if(api.playing) {
                                            evt.preventDefault();
                                            api.pause();
                                            evt.stopPropagation();
                                        } else if (api.paused) {
                                            evt.preventDefault();
                                            api.resume();
                                            evt.stopPropagation();
                                        }
                                    }
                                });

                            $('.fp-timeline')
                                .attr({'tabindex':0,'aria-label':'Use the left and right arrow keys to seek backwards and forwards','role':'slider'})
                                .keydown(function(evt){
                                    if (evt.keyCode == 37) {
                                        evt.preventDefault();
                                        api.seek(false);
                                        evt.stopPropagation();
                                    } else if (evt.keyCode == 39) {
                                        evt.preventDefault();
                                        api.seek(true);
                                        evt.stopPropagation();
                                    } else if (evt.keyCode == 13 || evt.keyCode == 32) {
                                        evt.preventDefault();
                                        evt.stopPropagation();
                                    }
                                });

                            $('.fp-volumebtn')
                                .attr({'tabindex':0,'aria-label':'Click to mute or unmute','role':'slider'})
                                .keypress(function(evt){
                                    if (evt.keyCode == 13 || evt.keyCode == 32) {
                                        evt.preventDefault();
                                        api.mute();
                                        evt.stopPropagation();
                                    }
                                });

                            $('.fp-volumebar')
                                .attr({'tabindex':0,'aria-label':'Use the up and down arrow keys to change volume','role':'slider'})
                                .keydown(function(evt){
                                    if (evt.keyCode == 38) {
                                        evt.preventDefault();
                                        api.volume(api.volumeLevel + 0.15);
                                        evt.stopPropagation();
                                    } else if (evt.keyCode == 40) {
                                        evt.preventDefault();
                                        api.volume(api.volumeLevel - 0.15);
                                        evt.stopPropagation();
                                    } else if (evt.keyCode == 13 || evt.keyCode == 32) {
                                        evt.preventDefault();
                                        evt.stopPropagation();
                                    }
                                });

                            // Custom Code for Player Accessibility --- END //
                        }).on('ready', function () {

                            var makeCCAndSpeedAccessible = function(){
                                // Custom Code for Player Accessibility --- START //

                                // if there's only captions, make the CC button toggle-able and hide the menu
                                if (scope.captionsIncluded && !scope.subtitlesIncluded && $('.fp-subtitle-menu a').length < 3) {
                                  $( "<style>.fp-cc-on { border-bottom: 4px solid #00abcd; margin-bottom: -4px !important; }</style>" ).appendTo("head");
                                  $('.fp-subtitle-menu').css('visibility', 'hidden');
                                    // set it as on initially
                                    $('.fp-cc').attr('title', 'Turn off closed captions');
                                    $('.fp-cc').addClass('fp-cc-on');
                                    $('.fp-cc').click(function () {
                                        var index = $($('.fp-selected').get(0)).attr('data-subtitle-index');
                                        if (index === "0") {
                                            $('a[data-subtitle-index="-1"]').get(0).click();
                                            $('.fp-cc').attr('title', 'Turn on closed captions');
                                            $('.fp-cc').removeClass('fp-cc-on');
                                        }
                                        else {
                                            $('a[data-subtitle-index="0"]').get(0).click();
                                            $('.fp-cc').attr('title', 'Turn off closed captions');
                                            $('.fp-cc').addClass('fp-cc-on');
                                        }
                                    });
                                }
                               else if (scope.subtitlesIncluded) {
                                  $('.fp-cc').attr('title', 'Turn off closed captions or subtitles');
                                  $('.fp-subtitle-menu a').click(function () {
                                  var index = $('.fp-subtitle-menu a').index(this);
                                  if (index === 0) {
                                      $('.fp-cc').attr('title', 'Turn on closed captions or subtitles');
                                  }
                                  else {
                                      $('.fp-cc').attr('title', 'Turn off closed captions or subtitles');
                                  }
                                  });
                               };

                               $('.fp-subtitle-menu strong').html(scope.ccMenuTitle);
                                $( "<style>.fp-subtitle-menu{ width: fit-content !important; padding-bottom: 10px; background-color: rgba(0, 0, 0, 0.9) !important; }</style>" ).appendTo("head");
                                $("<style>.flowplayer .fp-menu strong {text-transform: capitalize;text-align: left; font-size: medium; letter-spacing: 0px;}</style>").appendTo('head');
                                $("<style>.flowplayer .fp-selected:before {content: none;}</style>").appendTo('head');
                                $('<style></style>').appendTo('head');
                                $('<style>.fp-selected { font-weight: 700; }</style>').appendTo('head');
                                $.each($('.fp-subtitle-menu a'), function (k,v) {
                                    $(v).css('text-align', 'left');
                                    if($(v).html() === "Off") {
                                        $(v).css('padding-top', '10px');
                                    }
                                });

                                $( "<style>.fp-audio-menu{ width: fit-content !important; padding-bottom: 10px; background-color: rgba(0, 0, 0, 0.9) !important; }</style>" ).appendTo("head");
                                $('<style>.fp-audio-menu strong{text-align: center !important;} .fp-selected { font-weight: 700; } .fp-audio-menu a {text-align: left !important;}</style>').appendTo('head');

                                $('.fp-cc')
                                    .attr({'tabindex':0,'aria-label':'Click to show captions'})
                                    .focus(function() {
                                        $('.fp-cc').css({"outline": "#0b5fcc solid thick"});
                                    }).blur(function() {
                                        $('.fp-cc').css({"outline": "none"});
                                    })
                                    .keypress(function(evt) {
                                        if (evt.keyCode == 13 || evt.keyCode == 32) {
                                            if(video.subtitles.length) {
                                                if(api.subtitles.length) {
                                                    evt.preventDefault();
                                                    api.disableSubtitles();
                                                    $(this).attr({'aria-label':'Click to show captions'});
                                                    evt.stopPropagation();
                                                } else {
                                                    evt.preventDefault();
                                                    api.loadSubtitles(0);
                                                    $(this).attr({'aria-label':'Click to hide captions'});
                                                    evt.stopPropagation();
                                                }
                                            }
                                        }
                                    });
                                $('.fp-speed')
                                    .attr({'tabindex':0,'aria-label':'Use the up and down arrow keys to change playback speed','role':'button'})
                                    .focus(function() {
                                        $('.fp-speed').css({"outline": "#0b5fcc solid thick"});
                                    }).blur(function() {
                                        $('.fp-speed').css({"outline": "none"});
                                    })
                                    .keydown(function(evt){
                                        if (evt.keyCode == 38) {
                                            evt.preventDefault();
                                            api.speed(true);
                                            evt.stopPropagation();
                                        } else if (evt.keyCode == 40) {
                                            evt.preventDefault();
                                            api.speed(false);
                                            evt.stopPropagation();
                                        } else if (evt.keyCode == 13 || evt.keyCode == 32) {
                                            evt.preventDefault();
                                            evt.stopPropagation();
                                        }
                                    });

                                // Custom Code for Player Accessibility --- END //
                            };

                            scope.enableStats = true;
                            scope.triggerUnload = true;
                            //service used to keep track of video start/end - used for drop off rate
                            //moving this from 'resume' to 'ready' so it also works for iPhones
                            mediaDropOff.playMedia(true, false, scope.asset.cid, scope.asset.aid);

                            //set isViewed flag to 1; don't update for channel asset playback
                            CollectionService.GetCollection.get({cid:scope.asset.cid, type:''}, function(coll){

                                scope.collectionType = coll.type;
                                if(scope.collectionType !=='channel'){
                                    var markAsViewed = [];
                                    markAsViewed.push({collectionId: scope.asset.cid, assetId: scope.asset.aid, isViewed: "1"});
                                    AssetService.UpdateMetadata.update(markAsViewed);
                                }
                            });

                            // Disables controls while playing copyright notice
                            if (scope.asset.copyrightNoticeRequired) {
                                if (api.video.index === 1) {
                                    api.disable(false);
                                    scope.enableStats = true;
                                    makeCCAndSpeedAccessible();
                                } else if (api.video.index === 0) {
                                    api.disable(true);
                                    scope.enableStats = false;
                                }
                            } else {
                                makeCCAndSpeedAccessible();
                            }

                            // Custom Code for Player Accessibility --- START //

                            $(window).keyup(function (e) {
                                var code = (e.keyCode ? e.keyCode : e.which);
                                if (code == 9) {
                                    lastTabTime = (new Date).getTime();
                                    // Whenever tab is pressed, mimic mouseover
                                    if(element.hasClass('is-mouseout')) {
                                        element.addClass('is-mouseover').removeClass('is-mouseout');
                                    }
                                    setTimeout(function () {
                                        lastFocusTime = (new Date).getTime() - lastTabTime;
                                        // Only reset if it has been more than 5 seconds since the last time tab was pressed
                                        if (lastFocusTime > 5000 && element.hasClass('is-mouseover')){
                                            element.removeClass('is-mouseover').addClass('is-mouseout');
                                        }
                                    }, 5000);
                                }
                            });

                            // Custom Code for Player Accessibility --- END //

                        }).on('resume', function () {
                            // Fixes background image bug in the pause/resume logic.
                            scope.triggerUnload = true;
                            if (flowplayer.support.firstframe) {
                                element.removeClass("is-splash");
                            }
                            element.css({backgroundImage: 'none'});
                            element.children(".fp-cc").show();
                            element.children(".fp-audio").show();
                            $('.fp-playbtn').attr({'tabindex':0,'aria-label': 'Click to pause','role':'button'});

                        }).on('cuepoint', function(e, api, cuepoint) {
                             let divAudioOnlyCaptions = document.getElementById('divAudioOnlyCaptions')
                               if (cuepoint.subtitle && scope.showCoverArt === 'false') {
                                    divAudioOnlyCaptions.innerHTML = cuepoint.subtitle.text;
                               }
                        }).on('pause', function () {

                            var mediaDuration = api.video.duration;
                            var secondsPlayedWhenPaused = api.video.time;

                            if (scope.enableStats) {
                                if (mediaDropOff.playingDone) {
                                    // This is executed when the user starts playing the video and moves out of the playback page
//                                    var recordPlayback = new AssetService.RecordPlayback({
//                                        cid: mediaDropOff.collectionId,
//                                        aid: mediaDropOff.assetId,
//                                        type: 'S',
//                                        secondsPlayed: secondsPlayedWhenPaused,
//                                        mediaDuration: mediaDuration
//                                    });
//                                    recordPlayback.$save();
                                    scope.flowplayer.shutdown();
                                } else {
                                    // This is executed whenever the user pauses the video or when the playback finishes
                                    mediaPauseAndDropOff.pauseDropOff(true, mediaDropOff.collectionId, mediaDropOff.assetId, secondsPlayedWhenPaused, mediaDuration);
                                }
                            }
                            $('.fp-playbtn').attr({'tabindex':0,'aria-label': 'Click to play','role':'button'});
                        }).on('finish', function () {
                            element.css({backgroundImage: 'none'});

                            if(scope.enableStats){
                                var secondsPlayed = api.video.time;
                                var mediaDuration = api.video.duration;

                                // This is executed when playback finishes
                                var recordPlayback = new AssetService.RecordPlayback({
                                    cid: mediaDropOff.collectionId,
                                    aid: mediaDropOff.assetId,
                                    type: 'S',
                                    secondsPlayed: secondsPlayed,
                                    mediaDuration: mediaDuration
                                });
                                recordPlayback.$save();
                                mediaDropOff.hasFinished = true;
                                scope.triggerUnload = false;
                            }
                        }).on('unload', function () {
                          element.css({backgroundImage: 'none'});
                          if(scope.enableStats && scope.triggerUnload){
                              var secondsPlayed = api.video.time;
                              var mediaDuration = api.video.duration;
                              // This is executed when playback finishes
                              var recordPlayback = new AssetService.RecordPlayback({
                                  cid: mediaDropOff.collectionId,
                                  aid: mediaDropOff.assetId,
                                  type: 'S',
                                  secondsPlayed: secondsPlayed,
                                  mediaDuration: mediaDuration
                              });
                              recordPlayback.$save();
                              mediaDropOff.hasFinished = true;
                          }
                        }).on('fullscreen', function () {
                        parent.postMessage({
                            event_id: 'fs_quip_message',
                             data: {
                                origin: scope.flowplayer.conf.origin
                             }
                         },
                         "*");
                        focusTrap.activate();
                       }).on('fullscreen-exit', function () {
                     focusTrap.deactivate();
                    })
                    });
                };

                window.addEventListener('beforeunload', function(event) {
                    // This is executed when playback finishes
                    if (scope.flowplayer.playing) {
                        var recordPlayback = new AssetService.RecordPlayback({
                            cid: scope.asset.cid,
                            aid: scope.asset.aid,
                            type: 'S',
                            secondsPlayed: scope.flowplayer.video.time,
                            mediaDuration:  scope.flowplayer.video.duration
                        });
                        recordPlayback.$save();
                        mediaDropOff.hasFinished = true;
                    }
                }, false);

                window.addEventListener('message', (event) => {
                    if (event.data.event_id === 'fs_quip_message_ack') {
                        scope.flowplayer.pause();
                    }
                });

                /**
                 * Parse a timestamp as number of seconds.
                 *
                 * @param timeStamp
                 * @returns {number}
                 * @private
                 */
                var timeInSeconds = function(timeStamp) {
                    var timeData = /^([0-9]{2}):([0-9]{2}):([0-9]{2})$/.exec(timeStamp),
                        h = parseInt(timeData[1]),
                        m = parseInt(timeData[2]),
                        s = parseInt(timeData[3]);
                    return (h*3600)+(m*60)+s;
                };

                var loadAssetMedia = function(){
                    if (!scope.asset.drmMessage) {

                        if (scope.asset.type === 'Video' || scope.asset.type === 'Audio' || scope.asset.type === 'Clip') {

                            element.addClass("play-button");

                            if(scope.asset.type === 'Clip'){
                                AssetService.GetClipInfo.get({
                                    cid: scope.asset.cid,
                                    aid: scope.asset.aid
                                }, function (clip) {
                                    getAVMedia(clip);
                                });
                            } else if(scope.asset.isStreamable){
                                getAVMedia();
                            } else if(scope.asset.isDownloadable){
                                // Just show the thumbnail for downloadable assets
                                element.css({
                                    backgroundImage: 'url(' + scope.asset.thumbnailUrl + ')',
                                    backgroundSize: 'cover',
                                    backgroundRepeat: 'no-repeat',
                                    width: '100%',
                                    height: '100%'
                                });
                            }

                        } else {

                            element.addClass('non-av-player');
                            $('<input />', {
                                type: 'button',
                                value: 'Go Fullscreen',
                                id: 'fsbutton'
                            }).prependTo(element.parent());

                            if (scope.asset.type === 'Images') {

                                BlobMedia.getMedia({
                                    aid: scope.asset.aid,
                                    cid: scope.asset.cid,
                                    type: 'image'
                                }, function (result) {
                                    var mediaFile = result.mediaFile;
                                    if (mediaFile) {
                                        var imgUrl = URL.createObjectURL(mediaFile);
                                        $('<img />', {
                                            src: imgUrl,
                                            id: 'imgContainer'
                                        }).css({
                                            width    : '100%'
                                        }).appendTo(element);
                                        enableFS('imgContainer');
                                        var recordPlayback = new AssetService.RecordPlayback({
                                            cid: scope.asset.cid,
                                            aid: scope.asset.aid,
                                            type: 'S',
                                            secondsPlayed: null,
                                            mediaDuration: null
                                        });
                                        recordPlayback.$save();
                                    }
                                });
                            } else {
                                // TODO: Add a check to see if flash is supported - so a message can be shown on mobile devices ($.flash.available doesn't work on CCC BB)

                                element.css({backgroundImage: 'url(' + scope.asset.thumbnailUrl + ')'});

                                $('<div class="play-btn"/>').appendTo(element);

                                element.bind('click', function () {
                                    element.find('.play-btn').hide();
                                    if (scope.asset.type == 'zippedMedia') {

                                        ZipMedia.getMedia({
                                            aid: scope.asset.aid,
                                            cid: scope.asset.cid,
                                            type: 'zippedMedia'
                                        }, function (result) {
                                            if (result.mediaUrl) {
                                                $('<iframe />', {
                                                    src: result.mediaUrl,
                                                    id: 'zippedMediaFrame'
                                                }).css({
                                                    border   : 'none'
                                                }).appendTo(element);
                                                enableFS('zippedMediaFrame');
                                                var recordPlayback = new AssetService.RecordPlayback({
                                                    cid: scope.asset.cid,
                                                    aid: scope.asset.aid,
                                                    type: 'S',
                                                    secondsPlayed: null,
                                                    mediaDuration: null
                                                });
                                                recordPlayback.$save();
                                            }
                                        });

                                    } else if (scope.asset.type === 'Swf') {

                                        BlobMedia.getMedia({
                                            aid: scope.asset.aid,
                                            cid: scope.asset.cid,
                                            type: 'swf'
                                        }, function (result) {
                                            var mediaFile = result.mediaFile;
                                            if (mediaFile) {
                                                var swfUrl = URL.createObjectURL(mediaFile);
                                                var flashElement = $('<object>', {
                                                    id: 'swfContainer',
                                                    type: 'application/x-shockwave-flash',
                                                    data: swfUrl
                                                });

                                                $('<param />', {
                                                    name: 'movie',
                                                    value: swfUrl
                                                }).appendTo(flashElement);

                                                $('<param />', {
                                                    name: 'allowfullscreen',
                                                    value: true
                                                }).appendTo(flashElement);

                                                flashElement.css({
                                                     width    : '100%',
                                                     height   : '100%',
                                                     border   : 'none'
                                                }).appendTo(element);
                                                enableFS('swfContainer');
                                                var recordPlayback = new AssetService.RecordPlayback({
                                                    cid: scope.asset.cid,
                                                    aid: scope.asset.aid,
                                                    type: 'S',
                                                    secondsPlayed: null,
                                                    mediaDuration: null
                                                });
                                                recordPlayback.$save();
                                            }
                                        });
                                    }

                                });
                            }
                        }
                    } else {
                        element.addClass('non-av-player');
                        var drmTemplate = "<i class='fa fa-5x fa-ban'></i><p>" + scope.asset.drmMessage + "</p>";
                        element.append($(drmTemplate));
                    }
                };

                var enableFS = function(containerId) {
                    var fullScreenApi = {
                            supportsFullScreen: false,
                            requestFullScreen: function() {},
                            prefix: '',
                            isEdge: false
                        },
                        browserPrefixes = 'webkit moz o khtml'.split(' ');

                    if (typeof document.cancelFullScreen != 'undefined') {
                        fullScreenApi.supportsFullScreen = true;
                    } else if(typeof document.exitFullscreen != 'undefined'){
                        fullScreenApi.supportsFullScreen = true;
                        fullScreenApi.isEdge = true;
                    } else if(typeof document.msExitFullscreen != 'undefined'){
                        fullScreenApi.supportsFullScreen = true;
                        fullScreenApi.prefix = 'ms';
                    } else {
                        for(var i = 0, il = browserPrefixes.length; i < il; i++) {
                            fullScreenApi.prefix = browserPrefixes[i];

                            if(typeof document[fullScreenApi.prefix + 'CancelFullScreen'] != 'undefined') {
                                fullScreenApi.supportsFullScreen = true;
                                break;
                            }
                        }
                    }

                    if(fullScreenApi.supportsFullScreen) {
                        fullScreenApi.requestFullScreen = function(el) {
                            return this.prefix === '' ? (this.isEdge ? el.requestFullscreen() : el.requestFullScreen()) : (this.prefix === 'ms'? el['msRequestFullscreen']() : el[this.prefix + 'RequestFullScreen']());
                        };
                    }

                    // jQuery plugin
                    if(typeof jQuery != 'undefined') {
                        jQuery.fn.requestFullScreen = function() {

                            return this.each(function() {
                                var el = jQuery(this);
                                if (fullScreenApi.supportsFullScreen) {
                                    fullScreenApi.requestFullScreen(el);
                                }
                            });
                        };
                    }

                    window.fullScreenApi = fullScreenApi;

                    var fsbtn = document.getElementById('fsbutton'),
                        fsElement = document.getElementById(containerId);

                    fsbtn.addEventListener('click', function() {
                        window.fullScreenApi.requestFullScreen(fsElement);
                    }, true);
                };

                scope.$on('$stateChangeStart', function (event) {

                    if (mediaDropOff.videoPlayed === true) {
                        mediaDropOff.playMedia(false, true, mediaDropOff.collectionId, mediaDropOff.assetId);
                        if (mediaPauseAndDropOff.isPlayed === true && mediaPauseAndDropOff.isPaused === true && !mediaDropOff.hasFinished) {
                            mediaDropOff.playingDone = false;
                        }
                    }
                    if(scope.enableStats){
                        // This is executed when the user pauses a video and then moves out of the page
                        if (mediaPauseAndDropOff.isPlayed === true && mediaPauseAndDropOff.isPaused === true && !mediaDropOff.hasFinished) {
                            var recordPlayback = new AssetService.RecordPlayback({
                                cid: mediaPauseAndDropOff.collectionId,
                                aid: mediaPauseAndDropOff.assetId,
                                type: 'S',
                                secondsPlayed: mediaPauseAndDropOff.secondsPlayed,
                                mediaDuration: mediaPauseAndDropOff.mediaDuration
                            });
                            recordPlayback.$save();
                        }
                    }

                    if(scope.flowplayer){
                        if(!scope.flowplayer.playing){
                            scope.flowplayer.shutdown();
                        }
                    }
                });

                scope.$watch('asset', function(){
                    if(scope.asset){
                        loadAssetMedia();
                    }
                })
            }
        }
    }]);
